module.exports = "/_next/static/resources/couple-71ce5855e2cc8d92a808297f30da8a46.webp";